import React from "react";
import styled from "styled-components";
import { spacing } from "../../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../../design-system/tokens/typography";
import { rawColors } from "../../../../design-system/tokens/colors";
import { borderRadius } from "../../../../design-system/tokens/borders";
import type { StepRenderProps } from "../ConnectorWizardModal.types";

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${spacing[2]};
  width: 100%;
  min-height: 240px;
  padding: ${spacing[6]};
  background-color: ${rawColors.structural.white};
  border: 1px dashed ${rawColors.stroke[300]};
  border-radius: ${borderRadius.xl};
`;

const Title = styled.p`
  margin: 0;
  ${typographyMixin("body", 2)}
  color: ${rawColors.text.highEmphasis};
`;

const Subtitle = styled.p`
  margin: 0;
  ${typographyMixin("body", 4)}
  color: ${rawColors.text.mediumEmphasis};
  text-align: center;
`;

/**
 * Placeholder step — used until the per-step Figma lands. Keeps the wizard
 * navigable end-to-end without committing to UI that will be redone.
 */
export const PlaceholderStep: React.FC<StepRenderProps> = ({ step }) => (
  <Card role="region" aria-label={`${step.label} step placeholder`}>
    <Title>{step.title ?? step.label}</Title>
    <Subtitle>
      This step will be implemented when its Figma reference is shared.
    </Subtitle>
  </Card>
);

export default PlaceholderStep;
